//console.log('secteur activite');

const secteurActiviteOnglet1 = document.getElementById('elementor-tab-title-2641');
const secteurActiviteOnglet2 = document.getElementById('elementor-tab-title-2642');
const secteurActiviteOnglet3 = document.getElementById('elementor-tab-title-2643');
const secteurActiviteOnglet4 = document.getElementById('elementor-tab-title-2644');

const tabs = [secteurActiviteOnglet1,secteurActiviteOnglet2,secteurActiviteOnglet3,secteurActiviteOnglet4];

tabs.forEach(el => {
    if(!el.classList.contains('elementor-active')){
        el.classList.add('tabActive');
        //console.log('non active');
    }else{
        el.classList.remove('tabActive');
        //console.log(' active ');
    }
});